var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar__nav"},_vm._l((_vm.nav),function(item){return _c('router-link',{key:item.name,staticClass:"sidebar__nav-item",attrs:{"to":item.path,"tag":"div"}},[_vm._v(_vm._s(item.name))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }